<template>
	<div class="stageIcon flex items-center">
		<w-avatar-group :size="22" :max-count="8">
			<template  v-for="item in getIconList" :key="item.id">
				{{ item }}
				<w-avatar class="stage-icon-item" v-if="item.icon">
					<img  :alt="item.name" :src="item.icon"/>
					<!-- <span v-else>{{ item.icon }}</span> -->
				</w-avatar>
			</template>
		</w-avatar-group>
	</div>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted, defineProps, computed } from 'vue';

// const dataList = ref([]); // 存储所有数据
const visibleData = ref([]); // 当前显示的数据
// const animationClass = ref(''); // 动画class
const currentIndex = ref(0); // 当前显示的数据起始索引
const itemRefs = ref([]); // 存储每个数据项的 DOM 引用
const intervalId = ref(null); // 定时器

const props = defineProps({
	dataList: {
		type: Array,
		default: () => [],
	},
});

const getIconList = computed(()=>{
	const seenIcons = new Set();
  return props.dataList.filter(item => {
    // 如果 icon 不为空且未曾遇到过，则添加到集合中
    if (item.icon && !seenIcons.has(item.icon)) {
      seenIcons.add(item.icon);
      return true; // 保留该元素
    }
    return !item.icon; // 如果 icon 为空，保留该元素
  });
})

// 监听 dataList 的变化，启动轮播
watch(
	() => props.dataList.length,
	() => {
		if (props.dataList.length) {
			if (intervalId.value == null) {
				// startCarousel();
			}
		}
	},
	{
		immediate: true,
	}
);

// 模拟动态添加数据
onMounted(() => {
	// console.log(props.dataList);
	
});
onUnmounted(() => {});
</script>

<style scoped lang="scss">
.stage-icon-item{
	background-color: var(--color-fill-2);
}
</style>
